/* esm.sh - @radix-ui/react-context-menu@2.2.16 */
export * from "/*@radix-ui/react-context-menu@2.2.16/esnext/react-context-menu.mjs";
